var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "flex flex-wrap items-center justify-between mb-4" },
        [
          _c("h4", { staticClass: "mb-0" }, [
            _vm._v(
              _vm._s(_vm.$t("subscription.detail_title_management")) +
                " #" +
                _vm._s(_vm.id)
            ),
          ]),
          _c(
            "router-link",
            { staticClass: "text-primary", attrs: { to: "/subscriptions" } },
            [
              _c("feather-icon", {
                staticClass: "h-4 w-4 mr-1 inline",
                attrs: { icon: "ArrowLeftIcon" },
              }),
              _vm._v(
                " " +
                  _vm._s(_vm.$t("subscription.back_to_list_management")) +
                  " "
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "vs-tabs",
        {
          attrs: { color: _vm.colorx },
          model: {
            value: _vm.tabIndex,
            callback: function ($$v) {
              _vm.tabIndex = $$v
            },
            expression: "tabIndex",
          },
        },
        [
          _c(
            "vs-tab",
            { attrs: { label: _vm.$t("subscription.tab_summary") } },
            [
              _c("vx-card", { staticClass: "mt-4" }, [
                _vm.loading
                  ? _c("div", { staticClass: "text-center py-8" }, [
                      _vm._v(_vm._s(_vm.$t("common.loading"))),
                    ])
                  : _vm.error
                  ? _c("div", { staticClass: "text-danger" }, [
                      _vm._v(_vm._s(_vm.error)),
                    ])
                  : _c(
                      "div",
                      { staticClass: "grid grid-cols-1 md:grid-cols-2 gap-4" },
                      [
                        _c("div", { staticClass: "md:col-span-2" }, [
                          _c("p", { staticClass: "text-sm text-grey" }, [
                            _vm._v(_vm._s(_vm.$t("subscription.user"))),
                          ]),
                          _c("p", { staticClass: "font-medium" }, [
                            _vm.subscription.user
                              ? _c("span", [
                                  _vm._v(_vm._s(_vm.subscription.user.name)),
                                ])
                              : _c("span", [_vm._v("—")]),
                            _vm.subscription.user && _vm.subscription.user.email
                              ? _c(
                                  "span",
                                  { staticClass: "text-sm text-grey" },
                                  [
                                    _vm._v(
                                      " · " +
                                        _vm._s(_vm.subscription.user.email) +
                                        " "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ]),
                        ]),
                        _c("div", [
                          _c("p", { staticClass: "text-sm text-grey" }, [
                            _vm._v(_vm._s(_vm.$t("subscription.plan"))),
                          ]),
                          _c("p", { staticClass: "font-medium" }, [
                            _vm._v(
                              _vm._s(
                                _vm.subscription.subscription_plan
                                  ? _vm.subscription.subscription_plan.name
                                  : "—"
                              )
                            ),
                          ]),
                        ]),
                        _c(
                          "div",
                          [
                            _c("p", { staticClass: "text-sm text-grey" }, [
                              _vm._v(_vm._s(_vm.$t("subscription.status"))),
                            ]),
                            _c(
                              "vs-chip",
                              {
                                staticClass: "text-base",
                                attrs: {
                                  transparent: "",
                                  color: _vm.getSubscriptionStatusColor(
                                    _vm.subscription.status
                                  ),
                                },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.subscription.status_label) +
                                    " "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                        _c("div", [
                          _c("p", { staticClass: "text-sm text-grey" }, [
                            _vm._v(
                              _vm._s(_vm.$t("subscription.payment_method"))
                            ),
                          ]),
                          _c("p", [_vm._v(_vm._s(_vm.paymentMethodLabel))]),
                        ]),
                        _c("div", [
                          _c("p", { staticClass: "text-sm text-grey" }, [
                            _vm._v(
                              _vm._s(_vm.$t("subscription.next_billing_at"))
                            ),
                          ]),
                          _c("p", [
                            _vm._v(
                              _vm._s(
                                _vm.formatDate(_vm.subscription.next_billing_at)
                              )
                            ),
                          ]),
                        ]),
                        _c("div", [
                          _c("p", { staticClass: "text-sm text-grey" }, [
                            _vm._v(_vm._s(_vm.$t("subscription.started_at"))),
                          ]),
                          _c("p", [
                            _vm._v(
                              _vm._s(
                                _vm.formatDate(_vm.subscription.started_at)
                              )
                            ),
                          ]),
                        ]),
                        _c("div", [
                          _c("p", { staticClass: "text-sm text-grey" }, [
                            _vm._v(_vm._s(_vm.$t("subscription.ends_at"))),
                          ]),
                          _c("p", [
                            _vm._v(
                              _vm._s(_vm.formatDate(_vm.subscription.ends_at))
                            ),
                          ]),
                        ]),
                        _c("div", { staticClass: "md:col-span-2" }, [
                          _c("p", { staticClass: "text-sm text-grey" }, [
                            _vm._v(
                              _vm._s(_vm.$t("subscription.latest_invoice"))
                            ),
                          ]),
                          _c("p", [
                            _vm._v(
                              _vm._s(
                                _vm.subscription.latest_invoice_status_label ||
                                  "—"
                              )
                            ),
                          ]),
                        ]),
                        _c("div", { staticClass: "md:col-span-2" }, [
                          _c("p", { staticClass: "text-sm text-grey" }, [
                            _vm._v(
                              _vm._s(_vm.$t("subscription.last_paid_invoice"))
                            ),
                          ]),
                          _c("p", [
                            _vm._v(
                              _vm._s(
                                _vm.subscription.last_paid_invoice_display ||
                                  "—"
                              )
                            ),
                          ]),
                        ]),
                      ]
                    ),
              ]),
            ],
            1
          ),
          _c(
            "vs-tab",
            { attrs: { label: _vm.$t("subscription.tab_invoices") } },
            [
              _c(
                "vx-card",
                { staticClass: "mt-4" },
                [
                  _vm.loading
                    ? _c("div", { staticClass: "text-center py-8" }, [
                        _vm._v(_vm._s(_vm.$t("common.loading"))),
                      ])
                    : !_vm.invoices.length
                    ? _c("div", { staticClass: "text-center py-8 text-grey" }, [
                        _vm._v(" " + _vm._s(_vm.$t("msg_none")) + " "),
                      ])
                    : _c(
                        "vs-table",
                        {
                          staticClass: "mt-2",
                          attrs: { data: _vm.invoices },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function (ref) {
                                var data = ref.data
                                return _vm._l(data, function (row) {
                                  return _c(
                                    "vs-tr",
                                    { key: row.id },
                                    [
                                      _c("vs-td", [
                                        _vm._v(
                                          _vm._s(
                                            row.period_index != null
                                              ? row.period_index
                                              : "—"
                                          )
                                        ),
                                      ]),
                                      _c("vs-td", [
                                        _vm._v(_vm._s(row.amount_display)),
                                      ]),
                                      _c("vs-td", [
                                        _vm._v(
                                          _vm._s(_vm.formatDate(row.due_at))
                                        ),
                                      ]),
                                      _c("vs-td", [
                                        _vm._v(
                                          _vm._s(_vm.formatDate(row.paid_at))
                                        ),
                                      ]),
                                      _c(
                                        "vs-td",
                                        [
                                          _c(
                                            "vs-chip",
                                            {
                                              staticClass: "text-sm",
                                              attrs: {
                                                transparent: "",
                                                color:
                                                  _vm.getInvoiceStatusColor(
                                                    row.status
                                                  ),
                                              },
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(row.status_label) +
                                                  " "
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                      _c("vs-td", [
                                        _vm._v(
                                          _vm._s(row.payment_method_label)
                                        ),
                                      ]),
                                    ],
                                    1
                                  )
                                })
                              },
                            },
                          ]),
                        },
                        [
                          _c(
                            "template",
                            { slot: "thead" },
                            [
                              _c("vs-th", [
                                _vm._v(
                                  _vm._s(_vm.$t("subscription.invoice_period"))
                                ),
                              ]),
                              _c("vs-th", [
                                _vm._v(
                                  _vm._s(_vm.$t("subscription.invoice_amount"))
                                ),
                              ]),
                              _c("vs-th", [
                                _vm._v(
                                  _vm._s(_vm.$t("subscription.invoice_due_at"))
                                ),
                              ]),
                              _c("vs-th", [
                                _vm._v(
                                  _vm._s(_vm.$t("subscription.invoice_paid_at"))
                                ),
                              ]),
                              _c("vs-th", [
                                _vm._v(_vm._s(_vm.$t("subscription.status"))),
                              ]),
                              _c("vs-th", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "subscription.invoice_payment_method"
                                    )
                                  )
                                ),
                              ]),
                            ],
                            1
                          ),
                        ],
                        2
                      ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "vs-tab",
            { attrs: { label: "Grade de horários" } },
            [
              _vm.tabIndex === 2
                ? _c("subscription-slots", { attrs: { id: _vm.id } })
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }